import React from "react";
import { Navigate, Route } from "react-router-dom";
import { SALES_ROLES } from "../constants/roles";
import AppShell from "../layout/AppShell";
// Shared with the ops and pharmacy consoles -- see src/v2/layout/RequireRoles.jsx.
import RequireRoles from "../layout/RequireRoles";
import { SALES_NAV } from "./nav-config";
// Opt-in table refinements, same class the ops and pharmacy reorder routes apply.
import "../ops/theme/table-refinements.css";

import SalesOrdersPage from "./pages/orders";
import SalesQuotationsPage from "./pages/quotations";
import SalesRefundsPage from "./pages/refunds";
import OutstandingPage from "./pages/outstanding";
// The ops console's REAL TAT dashboard, mounted unchanged. Default export.
import TatDashboard from "../ops/pages/tat-dashboard";
import Home from "../../pages/home";
import { FutureOrders } from "../../pages/future-orders";
// Users + User Details — the legacy /users and /user/:id screens, mounted unchanged in
// every console. The users table links to `<current path>/:id`, so a row click stays in
// this console instead of jumping to the legacy /user/:id route.
import { Users } from "../../pages/users";
import UserDetails from "../../pages/user-details";

// Sales Console.
//

export const SALES_ROUTES = (
    <Route path="/v2/sales" element={<AppShell nav={SALES_NAV} />}>
        <Route index element={<Navigate to="orders" replace />} />
        <Route
            path="overview"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    {/* The same legacy /home charts the ops and pharmacy consoles render
                        as their Overview. Caveat inherited along with it: this is two
                        Chart.js line charts and only OrdersCount is fed by the API --
                        Cohort renders a checked-in
                        src/pages/home/components/charts/cohort/data.json, so that chart
                        is a static snapshot, not live data. Noted in src/v2/ops/routes.jsx
                        too; it is a property of the page, not of this console. */}
                    <Home />
                </RequireRoles>
            }
        />
        <Route
            path="orders"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    <SalesOrdersPage />
                </RequireRoles>
            }
        />
        <Route
            path="quotations"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    {/* Not the legacy Quotations page: this console adds Discount % and
                        Evital No and drops Duration / Days Left / Inventory No, per the
                        Sales prototype. It configures the SHARED quotations queue rather
                        than forking it -- see ./pages/quotations. */}
                    <SalesQuotationsPage />
                </RequireRoles>
            }
        />
        <Route
            path="reorders"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    <div className="ops-v2-table-refined h-full">
                        <FutureOrders />
                    </div>
                </RequireRoles>
            }
        />
        <Route
            path="refunds"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    {/* The v2 refunds table, shared with the Finance console and rendered
                        read-only here -- see ./pages/refunds. This replaced the legacy
                        /all-refunds mount: it adds the Approval Status column, and the
                        two backend gaps that mount inherited (the ignored `status` filter
                        and the missing patient name/phone) are now fixed. */}
                    <SalesRefundsPage />
                </RequireRoles>
            }
        />
        <Route
            path="outstanding"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    <OutstandingPage />
                </RequireRoles>
            }
        />
        <Route
            path="tat"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    <TatDashboard />
                </RequireRoles>
            }
        />
        <Route
            path="users"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    <Users />
                </RequireRoles>
            }
        />
        <Route
            path="users/:id"
            element={
                <RequireRoles roles={SALES_ROLES}>
                    <UserDetails />
                </RequireRoles>
            }
        />
    </Route>
);
